import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getContracts() {
    return defaultClient.get('/contracts')
  },
  postContractsStart() {
    return defaultClient.post('/contracts/start')
  },
  getContractSecureLink({ uuid, redirectUrl }) {
    return defaultClient.post(`/contracts/${uuid}/secure-link`, { redirectUrl })
  },
}
